export const GET_LEADERBOARD_START = 'GET_LEADERBOARD_START';
export const GET_LEADERBOARD_SUCCESS = 'GET_LEADERBOARD_SUCCESS';
export const GET_LEADERBOARD_FAIL = 'GET_LEADERBOARD_FAIL';
export const GET_LEADERBOARD_RESET = 'GET_LEADERBOARD_RESET';
